import { Filter } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { Template, TemplateProps } from './Template';
import { EngagementPostsFilterFormValues } from './schemaTypes';

export type EngagementPostsFilterProps = FilterAction<EngagementPostsFilterFormValues> &
  Omit<TemplateProps, 'onSubmit'>;

export const EngagementPostsFilter = ({ filter, setFilter, ...templateProps }: EngagementPostsFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
    <Template {...templateProps} />
  </Filter.Provider>
);

export * from './schemaTypes';
